(() => {
  'use strict';
  if (window.avonticIpadBundleOptionsV2) return;
  window.avonticIpadBundleOptionsV2 = true;
  const selector = '[data-av-ipad-bundle-options]';
  const states = new WeakMap();
  const verifiedModels = new Map();
  const duoHandle = 'ipad-a16-11-inch-case-stylus-bundle-avontic-essential-duo';
  const duoModels = ['A3354', 'A3355', 'A3356'];
  const normalize = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, '');
  const codes = value => [...new Set((String(value || '').toUpperCase().match(/\b(?:A\d{4}|SM-[A-Z0-9]+)\b/g) || []))];
  const kind = name => /^(?:(?:case|sleeve)\s+)?colou?r$/i.test(name) ? 'color' : /^keyboard\s+colou?r$/i.test(name) ? 'keyboard' : /size|model|device/i.test(name) ? 'model' : /style/i.test(name) ? 'style' : 'other';
  const modelCodes = value => [...new Set([...(Array.isArray(value?.models) ? value.models.flatMap(codes) : []), ...codes(value?.name)])];
  const styleToFamily = style => style === 'RhinoGuard Pro' ? 'pro' : style === 'RhinoGuard ArmorPro' ? 'armor' : style === 'RhinoGuard Apex 360 Command' ? 'apex' : '';
  const familyToStyle = family => family === 'armor' ? 'RhinoGuard ArmorPro' : family === 'apex' ? 'RhinoGuard Apex 360 Command' : 'RhinoGuard Pro';
  function parse(node) {
    try { return JSON.parse(node?.textContent || 'null'); } catch (_) { return null; }
  }
  function sourceModelCodes(source, selected) {
    if (source.handle === duoHandle) return duoModels;
    const index = source.options.findIndex(option => kind(option.name) === 'model');
    return modelCodes(selected[index]);
  }
  function resolve(source, selected, target, family, model) {
    const sourceCodes = sourceModelCodes(source, selected);
    const confirmed = sourceCodes.includes(model) ? model : '';
    const wantedCodes = confirmed ? [confirmed] : sourceCodes;
    const sourceModelIndex = source.options.findIndex(option => kind(option.name) === 'model');
    const selectedModel = selected[sourceModelIndex];
    const chosen = [];
    const questions = [];
    const targetIsDuo = target.handle === duoHandle;
    if (targetIsDuo && !wantedCodes.every(code => duoModels.includes(code))) {
      if (!wantedCodes.some(code => duoModels.includes(code))) return { blocked: true, reason: 'unavailable' };
      questions.push({ kind: 'model', position: -1, values: [{ id: 'duo-a16', name: 'iPad A16 11-inch (2025)', models: duoModels }] });
    }
    if (targetIsDuo && !wantedCodes.length) return { blocked: true, reason: 'reviewFit' };
    for (const option of target.options) {
      const type = kind(option.name);
      let candidates = [];
      if (type === 'model') {
        if (wantedCodes.length) {
          candidates = option.values.filter(value => wantedCodes.every(code => modelCodes(value).includes(code)));
          if (!candidates.length) {
            candidates = option.values.filter(value => wantedCodes.some(code => modelCodes(value).includes(code)));
            if (!candidates.length) {
              const exact = option.values.filter(value => !modelCodes(value).length && selectedModel && normalize(value.name) === normalize(selectedModel.name));
              if (exact.length === 1) { chosen.push({ position: option.position, value: exact[0] }); continue; }
              return { blocked: true, reason: option.values.every(value => modelCodes(value).length) ? 'unavailable' : 'reviewFit' };
            }
            questions.push({ ...option, kind: type, values: candidates });
            continue;
          }
        } else {
          const sourceIndex = source.options.findIndex(item => kind(item.name) === 'model');
          const sourceValue = selected[sourceIndex];
          candidates = option.values.filter(value => sourceValue && normalize(value.name) === normalize(sourceValue.name));
          if (!candidates.length) return { blocked: true, reason: 'reviewFit' };
        }
      } else if (type === 'style') {
        candidates = option.values.filter(value => normalize(value.name) === normalize(familyToStyle(family)));
      } else {
        const sourceIndex = source.options.findIndex(item => type === 'color' ? kind(item.name) === 'color' : normalize(item.name) === normalize(option.name));
        const sourceValue = selected[sourceIndex];
        if (sourceValue) candidates = option.values.filter(value => normalize(value.name) === normalize(sourceValue.name));
        if (!candidates.length && option.values.length === 1 && type !== 'color') candidates = option.values;
      }
      if (candidates.length === 1) chosen.push({ position: option.position, value: candidates[0] });
      else questions.push({ ...option, kind: type, values: candidates.length ? candidates : option.values });
    }
    return { chosen, questions, model: confirmed, blocked: false };
  }
  function buildUrl(target, chosen, model, localeRoot, pageUrl) {
    const url = new URL(target.url, pageUrl.origin);
    const prefix = String(localeRoot || '/').replace(/\/$/, '');
    if (prefix && url.pathname.startsWith('/products/')) url.pathname = prefix + url.pathname;
    ['preview_theme_id', '_fd', 'pb', 'currency', 'country', 'locale'].forEach(key => {
      if (pageUrl.searchParams.has(key)) url.searchParams.set(key, pageUrl.searchParams.get(key));
    });
    ['variant', 'smartfit_model', 'model', 'option_values'].forEach(key => url.searchParams.delete(key));
    const ids = chosen.filter(item => item.position > 0).sort((a, b) => a.position - b.position).map(item => item.value.id);
    url.searchParams.set('option_values', ids.join(','));
    if (model) {
      url.searchParams.set('model', model);
      url.searchParams.set('smartfit_model', model);
    }
    return url.toString();
  }
  const sharedText = () => parse(document.querySelector('[data-avt-messages]')) || {};
  const compatibleVariants = (target, chosen) => (target.variants || []).filter(variant =>
    variant.available && chosen.every(item => item.position < 1 || variant.options[item.position - 1] === item.value.name));
  function dialogChoices(state, filter = false) {
    const { result, target } = state.pending;
    const chosen = [...result.chosen];
    const inputs = [...state.dialog.querySelectorAll('select')];
    for (const input of inputs) {
      const question = result.questions[Number(input.dataset.questionIndex)];
      if (filter && target.variantsComplete) {
        for (const option of input.options) {
          const value = question.values.find(item => String(item.id) === option.value);
          option.disabled = Boolean(value && !compatibleVariants(target, [...chosen, { position: question.position, value }]).length);
        }
        if (input.selectedOptions[0]?.disabled) input.value = '';
      }
      const value = question.values.find(item => String(item.id) === input.value);
      if (value) chosen.push({ position: question.position, value });
    }
    return { chosen, complete: inputs.every(input => input.value), valid: !target.variantsComplete || compatibleVariants(target, chosen).length > 0 };
  }
  function cancelSelection(state) {
    window.AvonticSetupPurchase?.cancel(state);
    state.pending = null;
    state.request?.abort();
    state.request = null;
    state.checking = false;
    state.dialog.removeAttribute('aria-busy');
  }
  async function navigateSelection(state, chosen) {
    const pending = state.pending;
    const button = state.dialog.querySelector('[data-av-bundle-continue]');
    const message = state.dialog.querySelector('[data-av-bundle-dialog-message]');
    const text = sharedText();
    if (state.checking || !pending || !state.dialog.open) return;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    state.request = controller;
    state.checking = true;
    button.disabled = true;
    state.dialog.querySelectorAll('select').forEach(input => { input.disabled = true; });
    message.textContent = text.checking || state.text.checkAvailability;
    state.dialog.setAttribute('aria-busy', 'true');
    try {
      if (pending.target.variantsComplete && !compatibleVariants(pending.target, chosen).length) throw new Error('combination');
      const url = new URL(buildUrl(pending.target, chosen, pending.result.model, state.root.dataset.localeRoot, new URL(location.href)));
      const checkUrl = new URL(url);
      checkUrl.searchParams.set('view', 'avontic-selection');
      const response = await fetch(checkUrl, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('request');
      const selectionData = await response.json();
      const variant = selectionData.variant;
      if (selectionData.handle !== pending.target.handle || !variant?.available ||
          !chosen.every(item => item.position < 1 || variant.options[item.position - 1] === item.value.name)) throw new Error('combination');
      if (pending !== state.pending || pending.signature !== selection(state).map(value => value?.id).join(',')) throw new Error('changed');
      if (!state.dialog.open || controller.signal.aborted || state.request !== controller) return;
      url.searchParams.set('variant', variant.id);
      location.assign(url.toString());
    } catch (error) {
      if (state.pending !== pending || state.request !== controller || !state.dialog.open) return;
      message.textContent = error.message === 'combination'
        ? text.invalid_selection || 'This combination is unavailable. Please choose another option.'
        : text.retry_selection || 'We could not confirm this setup. Please try again.';
      button.disabled = false;
    } finally {
      window.clearTimeout(timeout);
      if (state.request === controller) {
        state.request = null;
        state.checking = false;
        state.dialog.removeAttribute('aria-busy');
        state.dialog.querySelectorAll('select').forEach(input => { input.disabled = false; });
      }
    }
  }
  function selection(state) {
    const picker = state.scope.querySelector(`variant-picker[handle="${CSS.escape(state.source.handle)}"]`);
    const form = picker && document.getElementById(picker.getAttribute('form-id'));
    const controls = Array.from(form?.elements || picker?.querySelectorAll('[data-option-position]') || []);
    return state.source.options.map(option => {
      const control = controls.find(element => String(element.dataset?.optionPosition) === String(option.position) && (element.checked || element.tagName === 'SELECT'));
      return option.values.find(value => control && String(value.id) === String(control.value)) || option.values.find(value => value.selected) || null;
    });
  }
  function currentModel(state, selected) {
    const availableCodes = sourceModelCodes(state.source, selected);
    const eventModel = verifiedModels.get(state.source.id);
    const params = new URLSearchParams(location.search);
    const urlModel = codes(params.get('model'))[0];
    const smartfitModel = codes(params.get('smartfit_model'))[0];
    const inputModel = codes(state.scope.querySelector('[data-av-pdp-model-input]')?.value)[0];
    return [eventModel, urlModel, smartfitModel, inputModel].find(value => value && availableCodes.includes(value)) || '';
  }
  function cardResolution(state, card) {
    const selected = selection(state);
    const target = state.products.get(card.dataset.avBundleTarget);
    if (!target || selected.some(value => !value)) return { blocked: true, reason: 'reviewFit' };
    return resolve(state.source, selected, target, card.dataset.avBundleCardFamily, currentModel(state, selected));
  }
  function update(state) {
    const selected = selection(state);
    const styleIndex = state.source.options.findIndex(option => kind(option.name) === 'style');
    const currentStyle = selected[styleIndex]?.name || '';
    const selectedFamily = styleToFamily(currentStyle);
    if (state.root.dataset.bundleFamily === 'shared' && state.lastStyle !== currentStyle) {
      state.lastStyle = currentStyle;
      const note = state.root.querySelector('[data-av-bundle-selected-style]');
      if (note) note.textContent = state.text.selectedStyle.replace('__STYLE__', currentStyle);
      state.root.querySelectorAll('[data-av-bundle-family-group]').forEach(group => { group.open = group.dataset.avBundleFamilyGroup === selectedFamily; if (state.root.hasAttribute('data-av-family-chooser')) group.hidden = group.dataset.avBundleFamilyGroup !== selectedFamily; });
    }
    state.root.querySelectorAll('[data-av-bundle-target]').forEach(card => {
      const current = card.dataset.avBundleTarget === state.source.handle && (state.root.dataset.bundleFamily !== 'shared' || selectedFamily === card.dataset.avBundleCardFamily);
      card.classList.toggle('is-current', current);
      if (current) card.setAttribute('aria-current', 'page');
      else card.removeAttribute('aria-current');
      const result = cardResolution(state, card);
      const action = card.querySelector('[data-av-bundle-card-action]');
      if (state.root.hasAttribute('data-av-family-chooser')) {
        card.dispatchEvent(new CustomEvent('avontic:family-match', { bubbles: true, detail: { source: state.source, selected, target: state.products.get(card.dataset.avBundleTarget), result, current, sourceUrl: buildUrl(state.source, selected.filter(Boolean).map((value, i) => ({ position: state.source.options[i].position, value })), currentModel(state, selected), state.root.dataset.localeRoot, new URL(location.href)), targetUrl: !result.blocked && !result.questions.length ? buildUrl(state.products.get(card.dataset.avBundleTarget), result.chosen, result.model, state.root.dataset.localeRoot, new URL(location.href)) : null } }));
      }
      if (state.root.hasAttribute('data-av135-curated')) {
        card.hidden = Boolean((!card.hasAttribute('data-av-purchase-offer') && result.blocked && result.reason === 'unavailable') || (state.root.dataset.bundleFamily === 'shared' && selectedFamily && selectedFamily !== card.dataset.avBundleCardFamily));
        card.dataset.av135Match = !result.blocked && !result.questions.length ? 'exact' : 'review';
        if (card.dataset.av135Match !== 'exact') {const price=card.querySelector('.av-ibo__price');if(price?.dataset.av135From) price.textContent=price.dataset.av135From;delete card.dataset.av135Quote;}
      }
      if (card.hasAttribute('data-av-setup-card')) {
        const target = state.products.get(card.dataset.avBundleTarget);
        const exact = !result.blocked && !result.questions.length;
        const productUrl = new URL(buildUrl(target, exact ? result.chosen : [], exact ? result.model : null, state.root.dataset.localeRoot, new URL(location.href)));
        if (!exact) productUrl.searchParams.delete('option_values');
        card.querySelectorAll('[data-av-bundle-product-link]').forEach(link => {
          link.href = productUrl.toString();
          if (current) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        card.dataset.avBundleNeedsChoice = String(!exact);
        if (action) {
          action.disabled = current;
          action.setAttribute('aria-haspopup', 'dialog');
          action.setAttribute('aria-controls', state.dialog.id);
          action.textContent = current ? state.text.current : result.blocked ? state.text.checkAvailability : exact ? action.dataset.available === 'true' ? state.text.view : state.text.checkAvailability : choicePrompt(state, result.questions);
        }
        return;
      }
      if (current) {
        card.removeAttribute('href');
        card.removeAttribute('aria-haspopup');
        card.dataset.avBundleNeedsChoice = 'false';
        if (action) action.textContent = state.text.current;
        return;
      }
      card.dataset.avBundleNeedsChoice = String(result.blocked || result.questions.length > 0);
      if (!result.blocked && !result.questions.length) {
        const nextHref = buildUrl(state.products.get(card.dataset.avBundleTarget), result.chosen, result.model, state.root.dataset.localeRoot, new URL(location.href));
        if (card.hasAttribute('data-av-purchase-offer') && card.href !== nextHref) {
          card.dataset.avPurchaseApproved = 'pending';
          delete card.dataset.av135Variant;
          const delta = card.querySelector('[data-av-purchase-delta]');
          if (delta) delta.textContent = 'Checking your selection…';
        }
        card.href = nextHref;
        card.setAttribute('aria-haspopup', 'dialog');
        if (action) action.textContent = current ? state.text.current : action.dataset.available === 'true' ? state.text.view : state.text.checkAvailability;
      } else {
        if (card.hasAttribute('data-av-purchase-offer')) {
          card.dataset.avPurchaseApproved = 'review';
          delete card.dataset.av135Variant;
          const delta = card.querySelector('[data-av-purchase-delta]');
          if (delta) delta.textContent = result.blocked ? state.text[result.reason] : choicePrompt(state, result.questions) + ' to confirm your setup.';
          const price = card.querySelector('.av-ibo__price');
          if (price?.dataset.av135From) price.textContent = 'From ' + price.dataset.av135From;
        }
        card.href = `#${state.dialog.id}`;
        card.setAttribute('aria-haspopup', 'dialog');
        if (action) action.textContent = result.blocked ? state.text.checkAvailability : choicePrompt(state, result.questions);
      }
    });
  }
  function choicePrompt(state, questions) {
    if (questions.some(question => question.kind === 'model')) return state.text.chooseModel;
    if (questions.some(question => question.kind === 'color')) return state.text.chooseColor;
    if (questions.some(question => question.kind === 'keyboard')) return state.text.chooseKeyboard;
    return state.text.chooseOption;
  }
  function openResolver(state, card) {
    if (state.purchase) return window.AvonticSetupPurchase.open(state, card, { cardResolution, selection, buildUrl, dialogChoices });
    cancelSelection(state);
    const result = cardResolution(state, card);
    const target = state.products.get(card.dataset.avBundleTarget);
    const container = state.dialog.querySelector('[data-av-bundle-dialog-options]');
    container.replaceChildren();
    state.dialog.querySelector('[data-av-bundle-dialog-title]').textContent = (card.dataset.avPurchaseTitle || card.querySelector('.av-ibo__name')?.textContent || card.querySelector('.av-ibo__label')?.textContent) || state.text.chooseOption;
    const reviewModels = result.blocked && state.root.dataset.setupBundleNavigation === 'true' && target?.url;
    const confirmLabel = state.dialog.querySelector('[data-av-bundle-continue]').textContent.trim();
    const confirmationMessage = state.text.confirm || 'Review your matching configuration, then choose “' + confirmLabel + '” to continue.';
    const message = reviewModels && result.reason === 'reviewFit' ? state.text.reviewBundleModels : result.blocked ? state.text[result.reason] : result.questions.length ? choicePrompt(state, result.questions) : confirmationMessage;
    const changes = [];
    const fixedFinish = card.dataset.avBundleFixedFinish;
    const colorIndex = state.source.options.findIndex(option => /colou?r|finish/i.test(option.name) && kind(option.name) !== 'keyboard');
    const selectedFinish = selection(state)[colorIndex]?.name;
    if (fixedFinish && selectedFinish && normalize(fixedFinish) !== normalize(selectedFinish)) changes.push(sharedText().fixed_finish.replace('__FINISH__', fixedFinish).replace('__CURRENT__', selectedFinish));
    if (card.dataset.avBundleAlternativeFamily) changes.push(card.dataset.avBundleFamilyMessage || sharedText().alternative_family);
    const dialogMessage = state.dialog.querySelector('[data-av-bundle-dialog-message]');
    const reviewMessage = [message, ...changes].join(' ');
    dialogMessage.textContent = reviewMessage;
    let summary = state.dialog.querySelector('[data-av-bundle-dialog-selection]');
    if (!summary) {
      summary = document.createElement('p');
      summary.setAttribute('data-av-bundle-dialog-selection', '');
      dialogMessage.before(summary);
    }
    summary.hidden = result.blocked;
    summary.textContent = '';
    if (reviewModels) {
      const link = document.createElement('a');
      const url = new URL(buildUrl(target, [], null, state.root.dataset.localeRoot, new URL(location.href)));
      url.searchParams.delete('option_values');
      link.href = url.toString();
      link.className = 'av-ibo__dialog-continue av-ibo__model-review';
      link.textContent = state.text.reviewBundleLink;
      container.append(link);
    }
    const proceed = state.dialog.querySelector('[data-av-bundle-continue]');
    proceed.hidden = result.blocked;
    proceed.disabled = true;
    state.pending = { result, target, changes, signature: selection(state).map(value => value?.id).join(',') };
    for (const [index, question] of (result.questions || []).entries()) {
      const label = document.createElement('label');
      label.textContent = question.kind === 'model' ? state.text.modelLabel : question.kind === 'color' ? state.text.colorLabel : question.name;
      const select = document.createElement('select');
      select.setAttribute('aria-label', label.textContent);
      select.required = true;
      select.dataset.questionIndex = String(index);
      select.append(new Option(state.text.placeholder, ''));
      question.values.forEach(value => select.append(new Option(value.name.split('|')[0].trim(), String(value.id))));
      label.append(select);
      container.append(label);
    }
    const check = () => {
      const choices = dialogChoices(state, true);
      proceed.disabled = !choices.complete || !choices.valid || state.checking;
      summary.textContent = [...choices.chosen].sort((a, b) => a.position - b.position).map(item => item.value.name.split('|')[0].trim()).join(' · ');
      summary.hidden = !summary.textContent;
      dialogMessage.textContent = choices.valid ? [choices.complete ? confirmationMessage : message, ...changes].join(' ') : sharedText().invalid_selection || 'This combination is unavailable. Please choose another option.';
    };
    container.onchange = check;
    if (!result.blocked) check();
    state.dialog.showModal();
    state.dialog.querySelector('[data-av-bundle-dialog-title]').focus({ preventScroll: true });
  }
  function initialize() {
    document.querySelectorAll(selector).forEach(root => {
      if (states.has(root)) return;
      const products = new Map();
      root.querySelectorAll('[data-av-bundle-product-data]').forEach(node => {
        const product = parse(node);
        if (product?.handle && Array.isArray(product.options)) products.set(product.handle, product);
      });
      const source = products.get(root.dataset.currentHandle);
      const dialog = root.querySelector('[data-av-bundle-dialog]');
      const text = parse(root.querySelector('[data-av-bundle-translations]'));
      if (!source || !dialog || !text) return;
      const state = { root, products, source, dialog, text, scope: root.closest('[id^="shopify-section-"]') || document };
      state.purchase = dialog.hasAttribute('data-av-setup-purchase') && Boolean(window.AvonticSetupPurchase);
      states.set(root, state);
      root.dataset.avBundleReady = 'true';
      dialog.id = `AvBundleResolver-${source.id}-${Math.random().toString(36).slice(2, 8)}`;
      const title = dialog.querySelector('[data-av-bundle-dialog-title]');
      title.id = dialog.id + '-title';
      title.tabIndex = -1;
      dialog.setAttribute('aria-labelledby', title.id);
      const message = dialog.querySelector('[data-av-bundle-dialog-message]');
      message.id = dialog.id + '-message';
      message.setAttribute('aria-live', 'polite');
      dialog.setAttribute('aria-describedby', message.id);
      const close = () => { if (state.purchasePosting) return; cancelSelection(state); dialog.close(); };
      dialog.querySelectorAll('[data-av-bundle-cancel]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('cancel', event => { if (state.purchasePosting) event.preventDefault(); else cancelSelection(state); });
      dialog.addEventListener('close', () => { if (!dialog.open) cancelSelection(state); });
      dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
      dialog.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        if (state.purchase) { window.AvonticSetupPurchase.submit(state, event); return; }
        const continueButton = dialog.querySelector('[data-av-bundle-continue]');
        if (event.submitter !== continueButton || continueButton.disabled || !dialog.open) return;
        const pending = state.pending;
        if (!pending || pending.result.blocked || pending.signature !== selection(state).map(value => value?.id).join(',')) { close(); update(state); return; }
        const choices = dialogChoices(state, true);
        if (choices.complete && choices.valid) navigateSelection(state, choices.chosen);
      });
      update(state);
      document.dispatchEvent(new CustomEvent('avontic:ipad-offers-ready'));
    });
  }
  function sync() {
    initialize();
    document.querySelectorAll(selector).forEach(root => { const state = states.get(root); if (state) update(state); });
  }
  ['pointerdown', 'focusin', 'click', 'auxclick'].forEach(name => document.addEventListener(name, event => {
    const card = event.target instanceof Element && event.target.closest('[data-av-bundle-target]');
    const state = card && states.get(card.closest(selector));
    if (!state) return;
    update(state);
    if (event.target.closest('[data-av-bundle-product-link]')) return;
    if (card.getAttribute('aria-current') === 'page') {
      if (name === 'click' || name === 'auxclick') event.preventDefault();
      return;
    }
    if (name === 'click' || name === 'auxclick') {
      event.preventDefault();
      openResolver(state, card);
    }
  }));
  document.addEventListener('avontic:pdp-fit-verification', event => {
    const detail = event.detail || {};
    if (detail.verified && /^A\d{4}$/.test(detail.modelNumber)) verifiedModels.set(String(detail.productId), detail.modelNumber);
    else verifiedModels.delete(String(detail.productId));
    sync();
  });
  ['variant:change', 'product:variant-change', 'variant:changed', 'shopify:section:load'].forEach(name => document.addEventListener(name, sync));
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element) || !event.target.closest('variant-picker, product-variants, form[action*="/cart/add"]')) return;
    sync();
    window.setTimeout(sync, 80);
    window.setTimeout(sync, 300);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector) || node.matches('variant-picker'))))) sync();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();



